import * as actionTypes from '../../snackBarActionTypes';
import { AppThunk } from '@greenkub-fronts/shared/interface';

export type SnackSeverityType = 'positive' | 'negative';

export const addSnackMessage =
  (severity: SnackSeverityType, content: string): AppThunk =>
  (dispatch, getState) => {
    const msgId = getState().snackbar.currentMessageId + 1;
    let messages = getState().snackbar.messages;

    if (content) {
      messages = [
        ...messages,
        {
          id: msgId,
          severity: severity,
          content: content,
        },
      ];
    }

    dispatch({
      type: actionTypes.ADD_SNACK_MESSAGE,
      payload: {
        currentMessageId: msgId,
        messages,
      },
    });
  };
